import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import ReactGa from "react-ga";

import "./Contact.scss";
import withMotion from "../../Utils/withMotion";
//Shapes
// import { TitleBar } from "../../Shapes/Shapes";

// SEO
import SEO from "../../SEO/index.js";
import StructuredData from "../../SEO/structuredData";

const Contact = () => {
  const history = useHistory();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const onSubmit = (event) => {
    event.preventDefault();
    const data = new FormData(event.target);
    setIsSubmitting(true);

    fetch("https://yardmap.activehosted.com/proc.php", {
      method: "POST",
      body: data,
      mode: "no-cors",
    })
      .then((response) => {
        history.push("/thank-you-org");
        setIsSubmitting(false);
        ReactGa.event({
          category: "Inquiry",
          action: `Sent an email.`,
        });
      })
      .catch((error) => console.log("Request failed", error));
  };

  return (
    <>
      <SEO
        title="Contact Us | Sun Valley, CA | Pacific Pavingstone"
        description="We're here to help! Please contact us here with any questions you have or call us at 818-273-1401. We will get back to you as soon as possible."
        profileURL={"https://www.pacificpavingstone.com/contact-us"}
        type="website"
      />
      <StructuredData
        orgaCreator={{
          "@context": "https://schema.org",
          "@type": "Organization",
          url: "https://www.pacificpavingstone.com/contact-us",
          contactPoint: [
            {
              "@type": "ContactPoint",
              telephone: "(818) 275-8613",
              contactType: "customer service",
            },
          ],
        }}
      />
      <div className="container-fluid page-contact">
        <div className="row justify-content-center">
          <div className="col-11">
            <div className="row justify-content-center panel-title">
              <div className="col-8 col-md-6 col-lg-3 text-center">
                <h3 className="text-uppercase">Phone</h3>
                {/* <TitleBar /> */}
                <h4 className="mt-3">
                  <a href="tel:8182758613">(818) 275-8613</a>
                </h4>
              </div>
            </div>
            <div className="row justify-content-center">
              <div className="col-8 col-md-6 col-lg-3 text-center mt-5">
                <h1 className="contact-title text-uppercase">Contact Form</h1>
                {/* <TitleBar /> */}
              </div>
            </div>
            <div className="row justify-content-center mt-3">
              <div className="col-12 text-center">
                <p>
                  We’re here to help! Please contact us here with any questions
                  you have. We will get back to you as soon as possible.
                </p>
              </div>
            </div>

            <form className="panel-form" onSubmit={onSubmit}>
              <fieldset disabled={isSubmitting}>
                <div className="row">
                  <div className="col-lg-5 offset-lg-1">
                    <input type="hidden" name="u" value="7" />
                    <input type="hidden" name="f" value="7" />
                    <input type="hidden" name="s" />
                    <input type="hidden" name="c" value="0" />
                    <input type="hidden" name="m" value="0" />
                    <input type="hidden" name="act" value="sub" />
                    <input type="hidden" name="v" value="2" />
                    <input
                      type="text"
                      name="firstname"
                      placeholder="First Name"
                      required
                    />
                    <input
                      type="text"
                      name="lastname"
                      placeholder="Last Name"
                      required
                    />
                    <input
                      type="text"
                      name="phone"
                      placeholder="Phone"
                      required
                    />
                    <input
                      type="text"
                      name="email"
                      placeholder="Email"
                      required
                    />
                    <input type="text" name="field[12]" placeholder="Zip" />
                    <label className="how-find" htmlFor="find">
                      How did you find us?
                      <select
                        name="field[30]"
                        className="find-options"
                        required
                      >
                        <option selected></option>
                        <option value="Google">Google</option>
                        <option value="Yahoo">Yahoo</option>
                        <option value="Bing">Bing</option>
                        <option value="Angie&#039;s List">
                          Angie&#039;s List
                        </option>
                        <option value="Houzz">Houzz</option>
                        <option value="Home Advisor">Home Advisor</option>
                        <option value="Yelp">Yelp</option>
                        <option value="Facebook">Facebook</option>
                        <option value="Instagram">Instagram</option>
                        <option value="Pasadena Showcase">
                          Pasadena Showcase
                        </option>
                        <option value="Outdoor Event">Outdoor Event</option>
                        <option value="Friend/Neighbor">Friend/Neighbor</option>
                        <option value="Mailer">Mailer</option>
                        <option value="Other">Other</option>
                      </select>
                    </label>
                  </div>
                  <div className="col-lg-5">
                    <p>I’m interested in (check all that apply)</p>
                    <div className="row mt-3">
                      <div className="col-6 col-md-4">
                        <input
                          data-autofill="false"
                          type="hidden"
                          name="field[31][]"
                          value="~|"
                        />
                        <label htmlFor="landscaping">
                          <input
                            id="field_31Landscaping"
                            type="checkbox"
                            name="field[31][]"
                            value="Landscaping"
                          />
                          &emsp; Landscaping
                        </label>
                        <label htmlFor="pavers">
                          <input
                            id="field_31Pavers"
                            type="checkbox"
                            name="field[31][]"
                            value="Pavers"
                          />
                          &emsp; Pavers
                        </label>
                        <label htmlFor="fire">
                          <input
                            id="field_31Fire Features"
                            type="checkbox"
                            name="field[31][]"
                            value="Fire Features"
                          />
                          &emsp; Fire Feature
                        </label>
                        <label htmlFor="outdoorKitchen">
                          <input
                            id="field_31Outdoor Kitchen"
                            type="checkbox"
                            name="field[31][]"
                            value="Outdoor Kitchen"
                          />
                          &emsp; Outdoor Kitchen
                        </label>
                      </div>
                      <div className="col-6 col-md-4">
                        <label htmlFor="poolDesign">
                          <input
                            id="field_31Pool Design"
                            type="checkbox"
                            name="field[31][]"
                            value="Pool Design"
                          />
                          &emsp; Pool Design
                        </label>
                        <label htmlFor="driveway">
                          <input
                            id="field_31Driveway"
                            type="checkbox"
                            name="field[31][]"
                            value="Driveway"
                          />
                          &emsp; Driveway
                        </label>
                        <label htmlFor="water">
                          <input
                            id="field_31Water Feature"
                            type="checkbox"
                            name="field[31][]"
                            value="Water Feature"
                          />
                          &emsp; Water Feature
                        </label>
                        <label htmlFor="masonry">
                          <input
                            id="field_31Masonry"
                            type="checkbox"
                            name="field[31][]"
                            value="Masonry"
                          />
                          &emsp; Masonry
                        </label>
                      </div>
                      <div className="col-6 col-md-4">
                        <label htmlFor="poolRemodel">
                          <input
                            id="field_31Pool Remodel"
                            type="checkbox"
                            name="field[31][]"
                            value="Pool Remodel"
                          />
                          &emsp; Pool Remodel
                        </label>
                        <label htmlFor="patio">
                          <input
                            id="field_31Patio"
                            type="checkbox"
                            name="field[31][]"
                            value="Patio"
                          />
                          &emsp; Patio
                        </label>
                        <label htmlFor="carpentry">
                          <input
                            id="field_31Carpentry"
                            type="checkbox"
                            name="field[31][]"
                            value="Carpentry"
                          />
                          &emsp; Carpentry
                        </label>
                        <label htmlFor="other">
                          <input
                            id="field_31Others"
                            type="checkbox"
                            name="field[31][]"
                            value="Others"
                          />
                          &emsp; Others
                        </label>
                      </div>
                    </div>
                    <div className="row mt-3">
                      <div className="col-12">
                        <p>Description</p>
                        <textarea name="field[26]" placeholder="" rows="5" />
                      </div>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="row justify-content-center mt-5 send-wrapper">
                      <div className="col-12 text-center">
                        <button
                          type="submit"
                          disabled={isSubmitting}
                          className="button-main button-blue"
                        >
                          Send
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </fieldset>
            </form>

            <div className="row panel-location">
              <div className="col-lg-3 offset-lg-2">
                <p className="mt-lg-5">
                  OFFICE AND SHOWROOM:
                  <br />
                  8309 Tujunga Ave Ste. 101
                  <br />
                  Sun Valley, CA 91352, USA
                </p>
                <p className="mt-5">
                  <br />
                  HOURS:
                  <br /> Monday - Friday: 9:00am - 6:00pm
                  <br />
                  Saturday: 9:00am - 5:00pm
                  <br />
                  Sunday: Closed
                </p>
              </div>
              <div className="col-lg-5 offset-lg-1 mt-5 mt-lg-0">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3299.049305728989!2d-118.38164968392185!3d34.22175941622342!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80c29417142276f9%3A0x7bf579635b317825!2sPacific%20Pavingstone!5e0!3m2!1sen!2sph!4v1609950623695!5m2!1sen!2sph"
                  width="100%"
                  height="450"
                  frameBorder="0"
                  allowFullScreen=""
                  aria-hidden="false"
                  tabIndex="0"
                  title="Location"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default withMotion(Contact);
